export default "__VITE_ASSET___Au4X3g2__"